import { useCreateSliceReducer } from '@components/Shared/State/hooks';
import { useMemo } from 'react';
import { countdownSlice } from './countdownSlice';
export const useCountdownReducer = () => {
    const [state, actions] = useCreateSliceReducer(countdownSlice);
    // Memoized helper functions to prevent unnecessary re-renders
    const helperActions = useMemo(() => ({
        configureCountdown: (config) => {
            // Set display configuration
            if (config.display) {
                actions.setDisplayConfig(config.display);
            }
            // Set countdown data
            if (config.countdownData != null) {
                actions.initializeCountdown(config.countdownData);
            }
            else if (config.countdownData === null) {
                // Explicitly set to null - clear countdown
                actions.removeCountdown();
            }
        },
        setDynamicCountdown: (countdownData, displayConfig) => {
            if (displayConfig) {
                actions.setDisplayConfig(displayConfig);
            }
            actions.initializeCountdown(countdownData);
        },
        // Dynamic management functions
        updateCountdownData: (countdownData) => {
            actions.updateCountdownData(countdownData);
        },
        removeCountdown: () => {
            actions.removeCountdown();
        },
        updateDisplayAndCountdown: (config) => {
            actions.updateDisplayAndCountdown(config);
        },
    }), [actions]);
    return {
        state,
        actions: Object.assign(Object.assign({}, actions), helperActions),
    };
};
